const createHTMLElement = require("../dom/createHTMLElement");

/**
 * @return {HTMLElement}
 */
module.exports = function successIcon() {
    return createHTMLElement(`
        <div>
            <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="37.5" cy="37.5" r="37.5" fill="#59C1A7"/>
                <line x1="32.7242" y1="53.1277" x2="56.1699" y2="27.2757" stroke="white" stroke-width="8"
                      stroke-linecap="round"/>
                <path d="M32.3271 52.7297L20 42" stroke="white" stroke-width="8" stroke-linecap="round"/>
            </svg>
        </div>
    `);
}